/* RESPONSIBLE TEAM: team-proactive-support */
const recentlyCreatedIds = new Set<string>();

export function markTemplateAsNew(id: string): void {
  recentlyCreatedIds.add(String(id));
}

export function isRecentlyCreatedTemplate(id: string): boolean {
  return recentlyCreatedIds.has(String(id));
}

export function clearRecentlyCreated(id: string): void {
  recentlyCreatedIds.delete(String(id));
}
